import { render, staticRenderFns } from "./HomeIndex.vue?vue&type=template&id=04a3079a&scoped=true&"
import script from "./HomeIndex.vue?vue&type=script&lang=js&"
export * from "./HomeIndex.vue?vue&type=script&lang=js&"
import style0 from "./HomeIndex.vue?vue&type=style&index=0&id=04a3079a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a3079a",
  null
  
)

export default component.exports